import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

//import Modal from 'react-modal';
import Header from "./header/header.js";
import { SearchBox } from "./searchBox/searchBox.js";
import DataTable from "./dataTable/dataTable.js";
import { userActions } from "../actions";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import { logoutCall } from "../util/userManager";
import "./invoice.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const initialState = {
  nmsc: "",
  docNumber1: "",
  docNumber2: "",
  docNumber3: "",
  fromDate: null,
  toDate: null,
  toDateErr: "",
  amount: "",
  currency: "",
  tableData: [],
  showResults: false,
  blocking: false,
  records: 0,
  status: 0,
  invoiceRole: "",
  deleteStatus: false,
  totalDownloadSize: 0,
};

/*const modalStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};*/

const currency = [
  { label: "-- Select --", value: "" },
  { label: "EUR", value: "EUR" },
  { label: "GBP", value: "GBP" },
  { label: "RUB", value: "RUB" },
  { label: "SEK", value: "SEK" },
  { label: "USD", value: "USD" },
];

class Invoice extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;

    this.logoutHandler = this.logoutHandler.bind(this);
    this.clearAllHandler = this.clearAllHandler.bind(this);
    this.searchResultHandler = this.searchResultHandler.bind(this);
    this.searchChangeHandler = this.searchChangeHandler.bind(this);
    this.toDateChangeHandler = this.toDateChangeHandler.bind(this);
    this.fromDateChangeHandler = this.fromDateChangeHandler.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.checkDates = this.checkDates.bind(this);
    this.paginationHandler = this.paginationHandler.bind(this);
    this.countDot = this.countDot.bind(this);
    this.bulkdownloadFile = this.bulkdownloadFile.bind(this);
    this.multipleDeleteFile = this.multipleDeleteFile.bind(this);
    this.setEmailPreference = this.setEmailPreference.bind(this);
  }

  componentWillMount() {
    console.log("inside will mount setting to initial state");
    this.setState(initialState);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tableData) {
      this.setState({ tableData: nextProps.tableData });
      this.setState({ records: nextProps.tableData.records });
      this.setState({
        totalDownloadSize: nextProps.tableData.totalDownloadSize,
      });
    } else {
      this.setState({ records: 0 });
    }
    this.setState({ blocking: nextProps.blocking });
    this.setState({ status: nextProps.status });
    this.setState({ url: nextProps.url });
  }

  setEmailPreference = (preference) => {
    const requestBody = {
      emailPreference: this.props.loggedInUser.user.invDistributors,
      department: "PSCG",
      preference: preference,
    };
    const { dispatch } = this.props;
    dispatch(userActions.saveEmail("/email/saveEmailPreference", requestBody));
  };
  // logoutHandler() {
  //     this.setState(initialState);
  //     const { dispatch } = this.props;
  //     dispatch(userActions.logout());
  // }
  logoutHandler = (e) => {
    console.log(" logout call: ");
    e.preventDefault();
    logoutCall();
  };

  clearAllHandler() {
    this.setState(initialState);
    const { dispatch } = this.props;
    dispatch(userActions.resetTable());
    this.setState({ showResults: false });
  }

  searchResultHandler(e) {
    e.preventDefault();
    const { dispatch } = this.props;
    this.setState({ deleteStatus: true });
    var formatfromDate;
    var formattoDate;
    if (this.state.fromDate) {
      formatfromDate = moment(this.state.fromDate).format("YYYY-MM-DD");
    }
    if (this.state.toDate) {
      formattoDate = moment(this.state.toDate).format("YYYY-MM-DD");
    }

    if (this.state.toDateErr) {
      this.setState({ toDateErr: "" });
    }
    const reqBody = {
      nmscCode: this.state.nmsc,
      docNumberStartWith: this.state.docNumber1,
      docNumberMidValue: this.state.docNumber2,
      docNumberEndWith: this.state.docNumber3,
      startDate: formatfromDate,
      endDate: formattoDate,
      amount: this.state.amount,
      currency: this.state.currency,
      orgCode: this.props.loggedInUser.user.orgCode,
      role: this.props.loggedInUser.user.roles,
      username: this.props.loggedInUser.user.userName,
    };

    //let token = this.props.user['x-access-token'];
    this.setState({ tableData: null });

    dispatch(userActions.getInvoice(reqBody));

    this.setState({ showResults: true });
  }

  paginationHandler(pageNumber, pageSize, sortColumnName, sortOrder) {
    const { dispatch } = this.props;
    this.state.multipleDelete = [];
    if (sortColumnName === "invoiceNumber") {
      sortColumnName = "number";
    }
    var formatfromDate;
    var formattoDate;
    if (this.state.fromDate) {
      formatfromDate = moment(this.state.fromDate).format("YYYY-MM-DD");
    }
    if (this.state.toDate) {
      formattoDate = moment(this.state.toDate).format("YYYY-MM-DD");
    }
    const reqBody = {
      nmscCode: this.state.nmsc,
      docNumberStartWith: this.state.docNumber1,
      docNumberMidValue: this.state.docNumber2,
      docNumberEndWith: this.state.docNumber3,
      startDate: formatfromDate,
      endDate: formattoDate,
      amount: this.state.amount,
      currency: this.state.currency,
      username: this.props.loggedInUser.user.userName,
      // "rows": pageSize ? pageSize : 10,
      // "page": pageNumber,
      // "sortOrder": sortOrder,
      // "sortCol": sortColumnName
      size: pageSize ? pageSize : 10,
      index: pageNumber - 1,
      sortOrder: sortOrder,
      sortColumn: sortColumnName,
      orgCode: this.props.loggedInUser.user.orgCode,
      role: this.props.loggedInUser.user.roles,
    };

    // let token = this.props.user['x-access-token'];
    this.setState({ tableData: [] });
    dispatch(userActions.getInvoice(reqBody));
    this.setState({ showResults: true });
  }

  searchChangeHandler(e) {
    const { name, value } = e.target;
    if (value === "") {
      this.setState({ [name]: "" });
    }
    if (name.indexOf("docNumber") !== -1) {
      var regEx1 = /^[a-z0-9]+$/i;
      if (regEx1.test(value)) {
        this.setState({ [name]: value });
      }
    } else if (name.indexOf("amount") !== -1) {
      var regEx2 = /^[0-9.,]+$/;
      if (value === "") {
        this.setState({ [name]: value });
      } else if (regEx2.test(value)) {
        if (this.countDot(value) <= 1) {
          this.setState({ [name]: value });
        }
      }
    } else {
      this.setState({ [name]: value });
    }
  }

  countDot(str) {
    var letter_Count = 0;
    for (var position = 0; position < str.length; position++) {
      if (str.charAt(position) === ".") {
        letter_Count += 1;
      }
    }
    return letter_Count;
  }

  toDateChangeHandler(date, key) {
    this.setState({ toDate: date, toDateErr: "" });
    this.checkDates(this.state.fromDate, date);
  }

  fromDateChangeHandler(date, key) {
    this.setState({ fromDate: date, toDateErr: "" });
    this.checkDates(date, this.state.toDate);
  }

  checkDates(fDate, tDate) {
    if (fDate && tDate) {
      // if ( moment(tDate).isSame(moment(fDate)) ) {
      //     this.setState({ toDate: null, toDateErr: "To date should be greater than From date" });
      // }
      if (tDate < fDate) {
        this.setState({
          toDate: null,
          toDateErr: "To date should be greater than From date",
        });
      }
    }
  }

  downloadFile(e) {
    console.log("File download function.");
    const { dispatch } = this.props;
    e.preventDefault();
    const { invnumber, invdate, nmsccode, filename } = e.target.attributes;

    //const invoiceDate = moment(invdate.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const invoiceDate = moment(invdate.value, "YYYY-MM-DD").format(
      "YYYY-MM-DD"
    );
    console.log("invoiceDate:", invoiceDate);
    const reqData = {
      invoiceNumber: invnumber.value,
      invoiceDate: invoiceDate,
      nmsccode: nmsccode.value,
      filename: filename.value,
    };

    dispatch(userActions.downloadFile(reqData));
  }
  bulkdownloadFile() {
    console.log("Bulk download function");
    const { dispatch } = this.props;

    var formatfromDate;
    var formattoDate;
    if (this.state.fromDate) {
      formatfromDate = moment(this.state.fromDate).format("YYYY-MM-DD");
    }
    if (this.state.toDate) {
      formattoDate = moment(this.state.toDate).format("YYYY-MM-DD");
    }

    if (this.state.toDateErr) {
      this.setState({ toDateErr: "" });
    }
    const reqBody = {
      nmscCode: this.state.nmsc,
      docNumberStartWith: this.state.docNumber1,
      docNumberMidValue: this.state.docNumber2,
      docNumberEndWith: this.state.docNumber3,
      startDate: formatfromDate,
      endDate: formattoDate,
      amount: this.state.amount,
      currency: this.state.currency,
      orgCode: this.props.loggedInUser.user.orgCode,
      role: this.props.loggedInUser.user.roles,
    };

    //let token = this.props.user['x-access-token'];
    this.setState({ tableData: null });

    dispatch(
      userActions.bulkDownladInvoice(
        "/invoiceData/bulkdownload",
        reqBody,
        this.onRefresh
      )
    );
  }
  onRefresh = () => {
    const { dispatch } = this.props;
    this.setState({ deleteStatus: true });
    var formatfromDate;
    var formattoDate;
    if (this.state.fromDate) {
      formatfromDate = moment(this.state.fromDate).format("YYYY-MM-DD");
    }
    if (this.state.toDate) {
      formattoDate = moment(this.state.toDate).format("YYYY-MM-DD");
    }

    if (this.state.toDateErr) {
      this.setState({ toDateErr: "" });
    }
    const reqBody = {
      nmscCode: this.state.nmsc,
      docNumberStartWith: this.state.docNumber1,
      docNumberMidValue: this.state.docNumber2,
      docNumberEndWith: this.state.docNumber3,
      startDate: formatfromDate,
      endDate: formattoDate,
      amount: this.state.amount,
      currency: this.state.currency,
      orgCode: this.props.loggedInUser.user.orgCode,
      role: this.props.loggedInUser.user.roles,
      username: this.props.loggedInUser.user.userName,
    };

    //let token = this.props.user['x-access-token'];
    this.setState({ tableData: null });

    dispatch(userActions.getInvoice(reqBody));

    this.setState({ showResults: true });
  };
  multipleDeleteFile(e) {
    const { dispatch } = this.props;
    console.log("search State:", this.state);
    this.setState({ clearSearch: true });
    // this.setState({deleteStatus:true});
    this.state.multipleDelete = e;

    const requestBody = {
      username: this.props.loggedInUser.user.userName,
      fileNamesArray: this.state.multipleDelete,
    };
    var formatfromDate;
    var formattoDate;
    if (this.state.fromDate) {
      formatfromDate = moment(this.state.fromDate).format("YYYY-MM-DD");
    }
    if (this.state.toDate) {
      formattoDate = moment(this.state.toDate).format("YYYY-MM-DD");
    }

    if (this.state.toDateErr) {
      this.setState({ toDateErr: "" });
    }
    const reqBody = {
      nmscCode: this.state.nmsc,
      docNumberStartWith: this.state.docNumber1,
      docNumberMidValue: this.state.docNumber2,
      docNumberEndWith: this.state.docNumber3,
      startDate: formatfromDate,
      endDate: formattoDate,
      amount: this.state.amount,
      currency: this.state.currency,
      orgCode: this.props.loggedInUser.user.orgCode,
      role: this.props.loggedInUser.user.roles,
      username: this.props.loggedInUser.user.userName,
    };
    console.log("MultipleInvoiceDeleteData:", this.state.multipleDelete);
    confirmAlert({
      title: "Delete Confirmation alert box",
      message:
        "Do You Want To Delete" +
        "  " +
        this.state.multipleDelete.length +
        "  " +
        "file?",
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            dispatch(
              userActions.deleteInvoiceFile(
                "/invoiceDelete/bulkdelete",
                requestBody,
                reqBody,
                this.onSuccess
              )
            );
            console.log("DeleteStatus:", this.state.deleteStatus);
          },
        },
        {
          label: "Cancel",
          // onClick: () =>{
          //     dispatch(userActions.deleteInvoiceStatus(this.onCancel))
          // }
        },
      ],
    });
    //console.log("DeleteStatus outside:", this.state.deleteStatus);

    //this.state.searchResultShipmentHandler(this.state.searchResult);
    //this.setState({deleteStatus:true});
  }

  componentWillUnmount() {
    this.setState({ showResults: true });
  }

  onSuccess = () => {
    this.setState({ deleteStatus: true });
  };
  onCancel = () => {
    this.setState({ deleteStatus: false });
  };
  render() {
    // Below condition will set default value, when there is no data available
    console.log("Props Invoice:", this.props);
    //this.props.user.distributors = this.props.loggedInUser.user.d ? this.props.loggedInUser.user : [];

    return (
      <div id="content" className="col-md-12 col-sm-12 col-xs-12">
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          message="Loading, please wait"
          keepInView
        >
          <Header
            logoutUser={this.logoutHandler}
            username={this.props.loggedInUser.user.userName}
            roles={this.props.loggedInUser.user.roles}
            emailPreference={
              this.props.loggedInUser.user.emailPreferenceInvoice
            }
            NmscEmailIds={this.props.loggedInUser.user.nmscEmailIds}
            setEmailPreference={this.setEmailPreference}
          />
          <SearchBox
            distributors={this.props.loggedInUser.user.invDistributors}
            // distributors={this.props.loggedInUser.user.distributors}
            currencyData={currency}
            data={this.state}
            onResetHandler={this.clearAllHandler}
            onSearchHandler={this.searchResultHandler}
            onChangeHandler={this.searchChangeHandler}
            toDateChangeHandler={this.toDateChangeHandler}
            fromDateChangeHandler={this.fromDateChangeHandler}
            role={this.props.loggedInUser.user.roles}
          />
          <DataTable
            data={this.state.tableData}
            records={this.state.records}
            onDownloadHandler={this.downloadFile}
            paginationHandler={this.paginationHandler}
            showResults={this.state.showResults}
            onBulkDowloadHandler={this.bulkdownloadFile}
            onMultipleDeleteHandler={this.multipleDeleteFile}
            deleteStatus={this.state.deleteStatus}
            role={this.props.loggedInUser.user.roles}
            downloadSize={this.state.totalDownloadSize}
            onCancel={this.onCancel}
          />
        </BlockUi>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggedInUser } = state.loginReducer;
  const { tableData, blocking, deleteStatus } = state.searchData;
  return {
    loggedInUser,
    tableData,
    blocking,
    deleteStatus,
  };
}

const connectedLoginPage = connect(mapStateToProps)(Invoice);
export { connectedLoginPage as Invoice };
